import "less/main.less";
import Backbone from "backbone";
import NativeAjax from "backbone.nativeajax";
Backbone.ajax = NativeAjax;
import { setLocale } from "./lib/locale";
import url from "./lib/url";
import Controller from "./lib/controller";
import View from "./lib/view";
var locale = url.deserialize(window && window.location && window.location.href).lang ||
    (window && window.navigator && window.navigator.language == "de" ? "de" : "en");
setLocale(locale);
/* Initialize controller and view */
var controller = new Controller();
var view = new View(controller);
/* Parse params */
var params = url.deserialize(location.href);
/* Configure controller based on url params */
console.info("params", params);
controller.configure(params);
